let ajax = require('sma.common/ajax');
/*
 Creates a temporary input in the same place as the dataEl 
 allowing you to hotswap submission titles or anything else

 Requires a trigger element to be set up externally
*/
class InlineEdit {
	constructor(config) {
		//where the editable data lives
		this.$dataEl = config.$dataEl;
		//what gets clicked the trigger the input creation
		this.$triggerEl = config.$triggerEl;

		//where this posts the data in the $dataEl
		this.url = config.url;
		//what key the POST contains
		this.dataKey = config.dataKey;

		this.$triggerEl.css('cursor', 'pointer');

		$(this.$triggerEl).click((e)=> {
			var existingText = $.trim(this.$dataEl.text());
			var editInput = this.createEditableInput(existingText);

			//clear existing element of text and insert the editable input
			this.updateText('');
			this.$dataEl.append(editInput);

			//focus new input
			editInput.focus();
		});

	}

	updateText(newText) {
		if(this.$dataEl.find('a').length > 0) {
			this.$dataEl.find('a').text(newText);
		} else {
			this.$dataEl.text(newText);
		}
	}

	createEditableInput(text) {
		var editInput = $("<input/>", {
			"type": "text",
			"value": text,
		});

		var on_blur = (e)=>{
			//get new data, fill up old element
			var newText = editInput.val();
			this.updateText(newText);

			//clean up temporary input
			editInput.remove();

			// No need to update the name server side if it hasn't changed
			if(text === newText) {
				return;
			}

			var data = {};
			data[this.dataKey] = newText;

			ajax.post({
				url: this.url,
				dataType: false, 
				data: data,
				callback: (data) => {
					
				}
			});

		};

		editInput.blur(on_blur);

		editInput.keypress(function (e) {
			if (e.which == 13) on_blur(e);
		});   

		return editInput;
	}
}

module.exports = {
	InlineEdit: InlineEdit
}
